module.exports = __webpack_public_path__ + "static/media/betsInCurrentRoom_1.0c6e1bfc.mp3";